<template>
  <div class="set-group-member">
    <div class="top-bar">
      <span class="tip-text">提示：成员规则：同成员仅允许在 1 个小组内；同组内成员不重复。</span>
      <el-button type="primary" @click="showOrHideGroupFormModalHandle">新增小组</el-button>
    </div>

    <CustomTable
      :column="groupTableColumns"
      :table-data="groupList"
      border
      stripe
      v-loading="loading"
      style="width: 100%;"
      :max-height="500"
    >
      <template #operation="{ row }">
        <el-link type="primary" style="margin-right: 12px;" @click="editGroupHandle(row)">编辑</el-link>
        <el-link type="danger" @click="deleteGroupHandle(row)">删除</el-link>
      </template>
    </CustomTable>

    <!-- 新增/编辑小组弹窗 -->
    <CustomModal
      v-model="showGroupFormModal"
      :title="currentGroup.groupInfoId ? '编辑小组' : '新增小组'"
      width="800px"
      @submitHandle="submitGroupHandle"
      @cancelHandle="showOrHideGroupFormModalHandle"
    >
      <AddOrEditGroup
        v-if="showGroupFormModal"
        ref="groupFormRef"
        :current-group="currentGroup"
        :group-list="groupList"
      />
    </CustomModal>
  </div>
</template>

<script>
import request from '@/utils/request'
import utils from '@/views/DoctorVisitLTC/utils/index'

export default {
  name: 'SetGroupMember',
  data() {
    return {
      loading: false,
      groupList: [],
      showGroupFormModal: false,
      currentGroup: {
        groupInfoId: '',
        groupName: '',
        leaderWorkNumber: '',
        memberWorkNumbers: []
      },
      // 编辑模式下原始成员工号快照，用于提交时计算差异
      originalMemberWorkNumbers: [],
      groupTableColumns: [
        { type: 'index', label: '序号', width: 80, align: 'center' },
        { prop: 'groupName', label: '小组名称', 'min-width': 100 },
        { prop: 'leaderNickName', label: '小组组长', 'min-width': 100 },
        { prop: 'memberNames', label: '小组成员', align: 'left', 'min-width': 200 },
        { prop: 'updateByName', label: '更新人', 'min-width': 100 },
        { prop: 'updateTimeStr', label: '更新时间', 'min-width': 160 },
        { label: '操作', width: 120, align: 'center', slotName: 'operation' }
      ]
    }
  },
  methods: {
    // 获取小组列表
    async getGroupList() {
      this.loading = true
      const params = {}
      try {
        const res = await request.get('/cluepool/pc/admin/group/list', params, '')
        if (res.code === 200) {
          this.groupList = (res.data || []).map(item => ({
            ...item,
            memberNames: (item.members || []).map(m => m.nickName).join('、'),
            updateTimeStr: item.updateTime ? new Date(item.updateTime).Format('yyyy-MM-dd hh:mm:ss') : ''
          }))
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('获取小组列表失败', error)
      } finally {
        this.loading = false
      }
    },

    // 显示/隐藏小组表单弹窗
    showOrHideGroupFormModalHandle(row) {
      if (row) {
        // 编辑模式
        const members = row.members || []
        this.currentGroup = {
          groupInfoId: row.groupInfoId,
          groupName: row.groupName,
          leaderWorkNumber: (members.filter(m => m.leader)[0] || {}).workNumber || '',
          memberWorkNumbers: members.map(m => m.workNumber)
        }
        // 快照原始成员工号，用于提交时计算增删差异
        this.originalMemberWorkNumbers = [...this.currentGroup.memberWorkNumbers]
      } else {
        // 新增模式
        this.currentGroup = {
          groupInfoId: '',
          groupName: '',
          leaderWorkNumber: '',
          memberWorkNumbers: []
        }
        this.originalMemberWorkNumbers = []
      }
      this.showGroupFormModal = !this.showGroupFormModal
    },

    // 编辑小组
    editGroupHandle(row) {
      this.showOrHideGroupFormModalHandle(row)
    },

    // 删除小组（二次确认）
    async deleteGroupHandle(row) {
      const validConfirm = await utils.messageBoxConfirm({
        title: '提示',
        message: `确认删除小组“${row.groupName}”？`
      })
      if (!validConfirm) return

      try {
        const params = { groupInfoId: row.groupInfoId }
        const res = await request.delete('/cluepool/pc/admin/group/delete', params, '')
        if (res.code === 200) {
          this.$message.success('删除成功')
          this.getGroupList()
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('删除小组失败', error)
      }
    },

    // 提交小组表单
    async submitGroupHandle() {
      this.$refs.groupFormRef.validate(async (valid) => {
        if (!valid) return
        let params = {}
        let url = ''
        let method = ''
        if (this.currentGroup.groupInfoId) {
          // 修改：计算原始成员与当前成员的差异
          const currentMembers = this.currentGroup.memberWorkNumbers || []
          const originalMembers = this.originalMemberWorkNumbers || []
          // 新增成员：当前有但原始没有的工号
          const addWorkNumbers = currentMembers.filter(num => !originalMembers.includes(num))
          // 删除成员：原始有但当前没有的工号
          const removeWorkNumbers = originalMembers.filter(num => !currentMembers.includes(num))

          url = '/cluepool/pc/admin/group/edit'
          method = 'put'
          params = {
            groupInfoId: this.currentGroup.groupInfoId,
            groupName: this.currentGroup.groupName,
            leaderWorkNumber: this.currentGroup.leaderWorkNumber,
            addWorkNumbers,
            removeWorkNumbers
          }
        } else {
          // 新增
          params = {
            groupInfoId: this.currentGroup.groupInfoId || '',
            groupName: this.currentGroup.groupName || '',
            leaderWorkNumber: this.currentGroup.leaderWorkNumber || '',
            memberWorkNumbers: this.currentGroup.memberWorkNumbers || []
          }
          url = '/cluepool/pc/admin/group/create'
          method = 'post'
        }
        if (!params.leaderWorkNumber) return this.$message.error('请选择小组组长')
        try {
          const res = await request[method](url, params, '')
          if (res.code === 200) {
            this.$message.success(this.currentGroup.groupInfoId ? '编辑成功' : '新增成功')
            this.showOrHideGroupFormModalHandle()
            this.getGroupList()
          } else {
            this.$message.error(res.message)
          }
        } catch (error) {
          console.log('保存小组失败', error)
        }
      })
    }
  },
  created() {
    this.getGroupList()
  },
  components: {
    CustomModal: () => import('@/views/DoctorVisitLTC/components/customModal/Custom_Modal.vue'),
    AddOrEditGroup: () => import('./components/AddOrEditGroup.vue'),
    CustomTable: () => import('@/components/CustomTable.vue')
  }
}
</script>

<style scoped lang="less">
.set-group-member {
  box-sizing: border-box;

  .top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    .tip-text {
      font-size: 13px;
      color: #E6A23C;
    }
  }
}
</style>
